import { render, staticRenderFns } from "./reportType2.vue?vue&type=template&id=0f4f8cba"
import script from "./reportType2.vue?vue&type=script&lang=js"
export * from "./reportType2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports